<template>
  <div class="customers-register" />
</template>

<script>

/**
 * Vue: Customers register (customers-register)
 * -----------------------------------------------------------------------------
 * Register page section.
 * - Limited interactivity component.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'CustomersRegister',

  data() {
    return {
      nodeSelectors: false,
      selectors: {
        nameField: '[name="customer[first_name]"]',
        lastNameField: '[name="customer[last_name]"]',
        emailField: '[type="email"]',
        passwordField: 'input[type="password"]',
        birthdayField: 'input[id="birthday"]',
        submitButton: '.sign-up[type="submit"]',
      },
      filledFields: [],
      birthday: '',
    }
  },

  mounted() {
    this.setNodeSelectors()

    if (!this.nodeSelectors.registerForm) {
      return
    }

    this.handleInputFieldChange()
    this.setEventListeners()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setNotification: 'setNotification',
    }),

    /**
     * Set node selectors.
      */
    setNodeSelectors() {
      this.nodeSelectors = {
        registerForm: document.querySelector('[js-register="form"]'),
        inputs: [
          ...document.querySelectorAll(this.selectors.passwordField),
          document.querySelector(this.selectors.nameField),
          document.querySelector(this.selectors.lastNameField),
          document.querySelector(this.selectors.emailField),
          document.querySelector(this.selectors.birthdayField),
        ],
        submitButton: document.querySelector(this.selectors.submitButton),
      }
    },

    /**
     * Enable/disable submit button.
     */
    handleInputFieldChange() {
      this.nodeSelectors.inputs.forEach((input) => {
        if (!input) {
          return
        }

        input.addEventListener('keyup', () => {
          if (input.value.length > 0 && !this.filledFields.includes(input)) {
            this.filledFields.push(input)
          } else if (input.value.length === 0 && this.filledFields.includes(input)) {
            const index = this.filledFields.indexOf(input)

            if (index > -1) {
              this.filledFields.splice(index, 1)
            }
          }

          if (this.filledFields.length > 4) {
            this.nodeSelectors.submitButton.removeAttribute('disabled')
          } else {
            this.nodeSelectors.submitButton.setAttribute('disabled', true)
          }

          if (input.id === 'birthday') {
            this.birthday = input.value.replace(/\D/g, '')
            if (this.birthday.length > 8) {
              this.birthday = this.birthday.slice(0, 8)
            }

            if (this.birthday.length > 4) {
              this.birthday = `${this.birthday.slice(0, 2)}/${this.birthday.slice(2, 4)}/${this.birthday.slice(4)}`
            } else if (this.birthday.length > 2) {
              this.birthday = `${this.birthday.slice(0, 2)}/${this.birthday.slice(2)}`
            }
            input.value = this.birthday
          }
        })
      })
    },

    /**
     * Set event listeners.
     */
    setEventListeners() {
      if (!this.$variable('settings.notifications.register')) {
        return
      }

      this.nodeSelectors.registerForm.addEventListener('submit', async(event) => {
        event.preventDefault()

        this.setNotification({
          displayUrl: this.$variable('routes.root'),
          text: this.$string('customers.notifications.register'),
          timeout: this.$timing('message'),
          type: 'success',
        })

        await cnvs.Sleep(0)
        this.nodeSelectors.registerForm.submit()
      })
    },

  },

}
</script>

<style lang="scss">
@import '~async/utils/checkbox-input/checkbox-input';
@import './customers-register';
</style>
